import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
} from 'reactstrap';

const ThisRow = styled(Row)`
  text-align: center;
  margin: 150px 0;
`;

const H1 = styled.h1`
  color: white;
  font-weight: 700;
  text-align: center;
`;

const Button = styled.a`
  background-color: #89E7C6;
  color: #1D1F35;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.7em;
  letter-spacing: 0.2em;
  padding: 18px 40px;
  display: inline-block;
  margin-top: 25px;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(120%);
    color: #1D1F35;
    text-decoration: none;
  }
`;

const LetsBuildTogether = () => (
  <ThisRow>
    <Col>
      <H1>let's build together</H1>
      <Button href="https://goo.gl/forms/gIYRCpY808iKFbiS2" target="_blank">start a project</Button>
    </Col>
  </ThisRow>
);

export default LetsBuildTogether;



// WEBPACK FOOTER //
// ./src/components/ui/LetsBuildTogether.js